@if (!shouldHide) {
<ng-form #stepForm="ngForm"
         class="block m-t-9">
    @switch (noShippingNeeded) {
    @case (true) {
    <p class="p2 col-12">{{ 'No shipping information required' | translate }}</p>
    }
    @case (false) {
    @if (!methods.length) {
    <p class="p2 col-2">
        {{ checkoutFormComponent.backendData.shipping.message || ('No shipping methods found for this delivery address.'
        | translate)}}</p>
    }
    <radio-group name="shippingMethod"
                 [value]="data.method"
                 [required]="true"
                 [(ngModel)]="data.method">
        @for (method of methods; track methodTrackFn($index, method); let first = $first) {
        <radio2 [ngClass]="{'m-t-3 m-t-2-s m-t-2-m' : !first}"
                [value]="method.code">
            <div radioTitle>
                <div class="flex flex-middle">
                    <p class="s1">{{method.title}}</p>
                    @if (method.code === 'ecom_shipping_ecom_shipping') {
                    <button type="button"
                            class="flex m-l-1"
                            [attr.aria-label]="'Checkout delivery' | translate"
                            [iCmsModalOpen]="'checkoutDeliveryInfoModal'">
                        <i class="icon-information inline-flex col-11"
                           aria-hidden="true"
                           style="font-size: 1.25rem"></i>
                    </button>
                    }
                </div>
                @if (methods?.length && basketTotalPrice >= 9) {
                <p class="p2">{{ 'We will contact you to arrange a delivery date' | translate}}</p>
                }
            </div>
            <p radioAside>
                <price [value]="method.price"
                       [useFreeLabel]="true"></price>
            </p>
            <p radioSubtitle>{{ method.lead_time}}</p>
            @if (method.description) {
            <div class="m-t-4"
                 radioBottom
                 [innerHTML]="method.description"></div>
            }
        </radio2>
        }
    </radio-group>
    <input-wrap>
        <input type="hidden"
               [(ngModel)]="data.method"
               name="shippingMethod"
               required>
    </input-wrap>
    }
    }
</ng-form>
}